import React, { useCallback, useEffect, useState } from "react";
import "../css/error.css";
import Layout from "../components/Layout/Layout";
import { Box, Button, Grid, Typography } from "@mui/material";
import err_list_ico from "../assets/error_list_new.svg";
import PopupModal from "../components/Modal/PopupModal";
import LayoutBanner from "../components/Layout/LayoutBanner";
import ErrorComponent from "../components/ErrorComponent";
import banner from "../assets/banner_error.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getApplicationError,
  getClasseError,
  getSkyPrepError,
  updateApplicationError,
  updateClasseError,
  updateSkyPrepError,
} from "../redux/slices/errorSlice";
import Loader from "../components/Loader/Loader";
import api from '../Api'

const Error = ({ errorType }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { app_error, classe_error, skyprep_error, isLoading } = useSelector(
    (state) => state.error
  );
  const [errMsg, setErrMsg] = useState("");
  const authData = useSelector((state) => state.auth.data);

  const getError = useCallback(() => {
    if (authData.access_token !== "") {
      api.defaults.headers.common.Authorization = authData?.access_token
        ? `Bearer ${authData?.access_token}`
        : "";
      if (errorType === "classe-error") {
        dispatch(getClasseError());
      } else if (errorType === "skyprep-error") {
        dispatch(getSkyPrepError());
      } else {
        dispatch(getApplicationError());
      }
    }
  }, [errorType, authData.access_token]);

  useEffect(() => {
    getError();
  }, [errorType]);
  const handleOpen = (data) => {
    setErrMsg(data?.message);
    setOpen(true);
  };
  const renderTable = () => {
    switch (errorType) {
      case "classe-error":
        return (
          <ErrorComponent
            new_count={classe_error?.newLogs?.length || 0}
            view_count={classe_error?.readLogs?.length || 0}
            handleOpen={(d) => {
              if (!d?.type) {
                dispatch(updateClasseError(d.id));
              }
              handleOpen(d);
            }}
            data={classe_error}
          />
        );
      case "skyprep-error":
        return (
          <ErrorComponent
            new_count={skyprep_error?.newLogs?.length || 0}
            view_count={skyprep_error?.readLogs?.length || 0}
            handleOpen={(d) => {
              if (!d?.type) {
                dispatch(updateSkyPrepError(d.id));
              }
              handleOpen(d);
            }}
            data={skyprep_error}
          />
        );
      case "app-error":
        return (
          <ErrorComponent
            new_count={app_error?.newLogs?.length || 0}
            view_count={app_error?.readLogs?.length || 0}
            handleOpen={(d) => {
              if (!d?.type) {
                dispatch(updateApplicationError(d.id));
              }
              handleOpen(d);
            }}
            data={app_error}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Layout>
      <LayoutBanner
        title={"Error"}
        body={
          "This screen provides users with insights into errors that occurred during the update process. It helps users identify the nature of the issue, whether it's a forbidden error, server error, or internal server error. By clicking on an error in the list, users can access detailed information about the error and find the appropriate contact person for resolution."
        }
        image={banner}
      />
      <Loader message={"Loading"} show={isLoading} />
      {renderTable()}
      <PopupModal
        open={open}
        width={700}
        handleClose={() => setOpen(false)}
        content={
          <>
            <Box variant="div" padding={"2% 3%"}>
              <Typography
                justifyContent={"center"}
                alignItems={"center"}
                variant="h6"
                fontWeight={600}
                display={"flex"}
                fontSize={24}
                color={"#EB4415"}
                marginBottom={2}
              >
                <span style={{ marginRight: "10px" }}>
                  <img src={err_list_ico} alt="err" />
                </span>{" "}
                Error
              </Typography>
              <Typography
                marginBottom={"20px"}
                fontSize={"16px"}
                textAlign={"center"}
              >
                {errMsg}
              </Typography>
              <Button
                variant="contained"
                size="large"
                sx={{
                  margin: "15px auto",
                  display: "block",
                  padding: "1% 6%",
                  borderRadius: "8px !important",
                  fontSize: "16px",
                  backgroundColor: "#338fcf",
                  "&:hover": {
                    backgroundColor: "#338fcf",
                    boxShadow:
                      "0px 2px 4px -1px rgb(0 0 0 / 10%), 0px 4px 5px 0px rgb(0 0 0 / 13%), 0px 1px 10px 0px rgb(0 0 0 / 5%) !important",
                  },
                }}
                onClick={() => {
                  setOpen(false);
                  setErrMsg("");
                }}
              >
                Done
              </Button>
            </Box>
          </>
        }
      />
    </Layout>
  );
};

export default Error;
